import { render, staticRenderFns } from "./new9.vue?vue&type=template&id=7227c00a&scoped=true&"
import script from "./new9.vue?vue&type=script&lang=js&"
export * from "./new9.vue?vue&type=script&lang=js&"
import style0 from "./new9.vue?vue&type=style&index=0&id=7227c00a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7227c00a",
  null
  
)

export default component.exports